import { colors } from '@material-ui/core';
export default {
  styleOverrides: {
    root: {
      color: colors.blue[800],
      Mui: {
        disabled: {
          color: 'red',
        },
      },
    },
    colorSecondary: {
      height: 42,
      color: colors.blue[800],
      borderColor: colors.blue[800],
      '&.Mui-checked': {
        color: colors.blue[800],
        //   '&:hover': {
        //     backgroundColor: colors.lightBlue[900],
        //     //   color: colors.lightBlue[800],
        //   },
      },
    },
  },
};
